// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1oena","colBig":"styles_colBig__2QlZ3","colSmall":"styles_colSmall__2Ibg4"};